export const WORDS = [
    {l1: "tunnag", l2: "duck", level: "Intro"},
{l1: "snog", l2: "nice", level: "Intro"},
{l1: "seo", l2: "This is", level: "Intro"},
{l1: "piseag", l2: "kitten", level: "Intro"},
{l1: "muc", l2: "pig", level: "Intro"},
{l1: "Mòrag", l2: "Morag", level: "Intro"},
{l1: "mòr", l2: "big", level: "Intro"},
{l1: "math", l2: "good", level: "Intro"},
{l1: "Irn bru", l2: "Irn Bru", level: "Intro"},
{l1: "Iain", l2: "John", level: "Intro"},
{l1: "gàidhlig", l2: "Gaelic", level: "Intro"},
{l1: "Eilidh", l2: "Helen", level: "Intro"},
{l1: "dona", l2: "bad", level: "Intro"},
{l1: "cù", l2: "dog", level: "Intro"},
{l1: "cearc", l2: "chicken", level: "Intro"},
{l1: "cat", l2: "cat", level: "Intro"},
{l1: "caraid", l2: "friend", level: "Intro"},
{l1: "Calum", l2: "Calum", level: "Intro"},
{l1: "caileag", l2: "girl", level: "Intro"},
{l1: "bò", l2: "cow", level: "Intro"},
{l1: "beag", l2: "little", level: "Intro"},
{l1: "balach", l2: "boy", level: "Intro"},
{l1: "Anna", l2: "Anne", level: "Intro"},
{l1: "agus", l2: "and", level: "Intro"},
{l1: "uisge-beatha", l2: "Whisky", level: "Food and Drink"},
{l1: "uisge", l2: "Water", level: "Food and Drink"},
{l1: "taigeis", l2: "haggis", level: "Food and Drink"},
{l1: "sin", l2: "that", level: "Food and Drink"},
{l1: "sgadan", l2: "herring", level: "Food and Drink"},
{l1: "seo", l2: "this", level: "Food and Drink"},
{l1: "salann", l2: "salt", level: "Food and Drink"},
{l1: "rìs", l2: "rice", level: "Food and Drink"},
{l1: "piobar", l2: "pepper", level: "Food and Drink"},
{l1: "is toil leam", l2: "I like", level: "Food and Drink"},
{l1: "ìm", l2: "butter", level: "Food and Drink"},
{l1: "idir", l2: "at all", level: "Food and Drink"},
{l1: "iasg", l2: "fish", level: "Food and Drink"},
{l1: "hama", l2: "hama", level: "Food and Drink"},
{l1: "guga", l2: "guga", level: "Food and Drink"},
{l1: "cha toil leam", l2: "I do not like", level: "Food and Drink"},
{l1: "cèic", l2: "cake", level: "Food and Drink"},
{l1: "càise", l2: "cheese", level: "Food and Drink"},
{l1: "buntàta", l2: "potato", level: "Food and Drink"},
{l1: "brot", l2: "soup", level: "Food and Drink"},
{l1: "brochan", l2: "porridge", level: "Food and Drink"},
{l1: "blasta", l2: "tasty", level: "Food and Drink"},
{l1: "biadh", l2: "food", level: "Food and Drink"},
{l1: "aran", l2: "bread", level: "Food and Drink"},
{l1: "tìoraidh", l2: "cheerio", level: "Phrases"},
{l1: "tì", l2: "tea", level: "Phrases"},
{l1: "tapadh leibh", l2: "thank you (formal)", level: "Phrases"},
{l1: "tapadh leat", l2: "thank you (informal)", level: "Phrases"},
{l1: "slàinte", l2: "cheers/health", level: "Phrases"},
{l1: "siùcar", l2: "sugar", level: "Phrases"},
{l1: "sgoinneil", l2: "great", level: "Phrases"},
{l1: "ollaimh", l2: "professor", level: "Phrases"},
{l1: "oidhche mhath", l2: "good night", level: "Phrases"},
{l1: "oidhche", l2: "night", level: "Phrases"},
{l1: "madainn mhath", l2: "good morning", level: "Phrases"},
{l1: "leat", l2: "with you (le)", level: "Phrases"},
{l1: "Iseabail", l2: "Isabella", level: "Phrases"},
{l1: "halò", l2: "hello", level: "Phrases"},
{l1: "feasgar math", l2: "good afternoon", level: "Phrases"},
{l1: "fàilte", l2: "welcome", level: "Phrases"},
{l1: "Eilidh", l2: "Helen", level: "Phrases"},
{l1: "Ealasaid", l2: "Elizabeth", level: "Phrases"},
{l1: "cofaidh", l2: "coffee", level: "Phrases"},
{l1: "ceud mìle fàilte", l2: "one hundred thousand welcomes", level: "Phrases"},
{l1: "bainne", l2: "milk", level: "Phrases"},
{l1: "athair", l2: "father", level: "Phrases"},
{l1: "Anndra", l2: "Andrew", level: "Phrases"},
{l1: "Anna", l2: "Anne", level: "Phrases"},
{l1: "a thidseir", l2: "teacher (vocative)", level: "Phrases"},
{l1: "a sheanair", l2: "grandfather (vocative)", level: "Phrases"},
{l1: "a phiuthar", l2: "sister (vocative)", level: "Phrases"},
{l1: "a mhàthair", l2: "mother (vocative)", level: "Phrases"},
{l1: "a charaid", l2: "friend (vocative)", level: "Phrases"},
{l1: "a bhràthair", l2: "brother (vocative)", level: "Phrases"},
{l1: "a bhalaich", l2: "boy (vocative)", level: "Phrases"},
{l1: "toilichte", l2: "happy", level: "Feelings"},
{l1: "thu", l2: "you (informal)", level: "Feelings"},
{l1: "spòrsail", l2: "fun", level: "Feelings"},
{l1: "sibh", l2: "you (formal)", level: "Feelings"},
{l1: "sgìth", l2: "tired", level: "Feelings"},
{l1: "Seumas", l2: "James", level: "Feelings"},
{l1: "mi", l2: "me", level: "Feelings"},
{l1: "iseabail", l2: "Isabella", level: "Feelings"},
{l1: "i", l2: "she", level: "Feelings"},
{l1: "gu math", l2: "well", level: "Feelings"},
{l1: "gabh mo leisgeul", l2: "excuse me", level: "Feelings"},
{l1: "e", l2: "he", level: "Feelings"},
{l1: "duilich", l2: "sorry", level: "Feelings"},
{l1: "crosta", l2: "cross", level: "Feelings"},
{l1: "ciamar a tha", l2: "how is...", level: "Feelings"},
{l1: "cho", l2: "so", level: "Feelings"},
{l1: "ceart gu leòr", l2: "all right", level: "Feelings"},
{l1: "brònach", l2: "sad", level: "Feelings"},
{l1: "Anndra", l2: "Andrew", level: "Feelings"},
{l1: "a-nis", l2: "now", level: "Feelings"},
{l1: "air bhioran", l2: "excited", level: "Feelings"},
{l1: "trang", l2: "busy", level: "About Me"},
{l1: "steòrnabhagh", l2: "Stornoway", level: "About Me"},
{l1: "Seòras", l2: "George", level: "About Me"},
{l1: "sasainn", l2: "England", level: "About Me"},
{l1: "muile", l2: "Mull", level: "About Me"},
{l1: "mòr", l2: "big", level: "About Me"},
{l1: "Màiri", l2: "Mary", level: "About Me"},
{l1: "lunnainn", l2: "London", level: "About Me"},
{l1: "leòdhas", l2: "Lewis", level: "About Me"},
{l1: "inbhir nis", l2: "Inverness", level: "About Me"},
{l1: "ìle", l2: "Islay", level: "About Me"},
{l1: "Iain", l2: "John", level: "About Me"},
{l1: "glaschu", l2: "Glasgow", level: "About Me"},
{l1: "èirinn", l2: "Ireland", level: "About Me"},
{l1: "dùn èideann", l2: "Edinburgh", level: "About Me"},
{l1: "dùn", l2: "Dun", level: "About Me"},
{l1: "cò", l2: "Who", level: "About Me"},
{l1: "canada", l2: "Canada", level: "About Me"},
{l1: "barraigh", l2: "Barra", level: "About Me"},
{l1: "alba nuadh", l2: "Nova Scotia", level: "About Me"},
{l1: "alba", l2: "Scotland", level: "About Me"},
{l1: "àlainn", l2: "beautiful", level: "About Me"},
{l1: "aimearaga", l2: "America", level: "About Me"},
{l1: "orm", l2: "on me", level: "Clothing"},
{l1: "lèine", l2: "shirt", level: "Clothing"},
{l1: "lèine-t", l2: "t-shirt", level: "Clothing"},
{l1: "sgiort", l2: "skirt", level: "Clothing"},
{l1: "bròg", l2: "shoe", level: "Clothing"},
{l1: "seall", l2: "look", level: "Clothing"},
{l1: "briogais", l2: "trousers", level: "Clothing"},
{l1: "bòtannan", l2: "boots", level: "Clothing"},
{l1: "còta", l2: "coat", level: "Clothing"},
{l1: "ort", l2: "on you", level: "Clothing"},
{l1: "bonaid", l2: "bonnet", level: "Clothing"},
{l1: "drathais", l2: "pants", level: "Clothing"},
{l1: "ag iarraidh", l2: "wanting", level: "Clothing"},
{l1: "a' ceannach", l2: "buying", level: "Clothing"},
{l1: "dreasa", l2: "dress", level: "Clothing"},
{l1: "speuclairean", l2: "glasses", level: "Clothing"},
{l1: "geansaidh", l2: "jumper", level: "Clothing"},
{l1: "uaireadair", l2: "watch", level: "Clothing"},
{l1: "sinn", l2: "we", level: "Clothing"},
{l1: "iad", l2: "they", level: "Clothing"},
{l1: "stocainnean", l2: "socks", level: "Clothing"},
{l1: "fèileadh", l2: "kilt", level: "Clothing"},
{l1: "aodach", l2: "clothing", level: "Clothing"},
{l1: "seacaid", l2: "jacket", level: "Clothing"},
{l1: "agam", l2: "at me", level: "Pets"},
{l1: "luch", l2: "mouse", level: "Pets"},
{l1: "eun", l2: "a bird", level: "Pets"},
{l1: "cuilean", l2: "puppy", level: "Pets"},
{l1: "brèagha", l2: "pretty", level: "Pets"},
{l1: "peata", l2: "pet", level: "Pets"},
{l1: "agad", l2: "at you", level: "Pets"},
{l1: "uan", l2: "lamb", level: "Pets"},
{l1: "each", l2: "horse", level: "Pets"},
{l1: "caora", l2: "sheep", level: "Pets"},
{l1: "glè mhath", l2: "very good", level: "Pets"},
{l1: "glè bheag", l2: "very small", level: "Pets"},
{l1: "glè", l2: "very", level: "Pets"},
{l1: "losgann", l2: "frog", level: "Pets"},
{l1: "àrd", l2: "high", level: "Pets"},
{l1: "òg", l2: "young", level: "Pets"},
{l1: "èibhinn", l2: "funny", level: "Pets"},
{l1: "gòrach", l2: "stupid", level: "Pets"},
{l1: "a' faicinn", l2: "seeing", level: "Pets"},
{l1: "a' cluinntinn", l2: "hearing", level: "Pets"},
{l1: "damhan-allaidh", l2: "spider", level: "Pets"},
{l1: "radan", l2: "rat", level: "Pets"},
{l1: "coineanach", l2: "rabbit", level: "Pets"},
{l1: "gobhar", l2: "goat", level: "Pets"},
{l1: "fliuch", l2: "wet", level: "Weather"},
{l1: "fuar", l2: "cold", level: "Weather"},
{l1: "gaothach", l2: "Windy", level: "Weather"},
{l1: "blàth", l2: "warm", level: "Weather"},
{l1: "grianach", l2: "sunny", level: "Weather"},
{l1: "ceòthach", l2: "misty", level: "Weather"},
{l1: "garbh", l2: "rough", level: "Weather"},
{l1: "bheil", l2: "Is", level: "Weather"},
{l1: "a-muigh", l2: "outward", level: "Weather"},
{l1: "a' faireachdainn", l2: "Feeling", level: "Weather"},
{l1: "sgòthach", l2: "Cloudy", level: "Weather"},
{l1: "gu math", l2: "well", level: "Weather"},
{l1: "dorcha", l2: "dark", level: "Weather"},
{l1: "cuidich mi", l2: "help me", level: "Phrases 2"},
{l1: "slàinte mhath", l2: "Good health", level: "Phrases 2"},
{l1: "dè tha dol", l2: "what's up", level: "Phrases 2"},
{l1: "a chàirdean", l2: "friends (vocative)", level: "Phrases 2"},
{l1: "tìoraidh an-dràsta", l2: "cheerio now", level: "Phrases 2"},
{l1: "dè", l2: "what", level: "Phrases 2"},
{l1: "a-rithist", l2: "again", level: "Phrases 2"},
{l1: "mòran taing", l2: "many thanks", level: "Phrases 2"},
{l1: "'s e do bheatha", l2: "you're welcome", level: "Phrases 2"},
{l1: "feumaidh mi falbh", l2: "I have to go", level: "Phrases 2"},
{l1: "na gabh dragh", l2: "never mind", level: "Phrases 2"},
{l1: "a' tuigsinn", l2: "Understanding", level: "Phrases 2"},
{l1: "bruidhinn nas slaodaiche", l2: "talk more slowly", level: "Phrases 2"},
{l1: "can sin a-rithist", l2: "say that again", level: "Phrases 2"},
{l1: "mar sin leat", l2: "goodbye", level: "Phrases 2"},
{l1: "beatha", l2: "Life", level: "Phrases 2"},
{l1: "dè an t-ainm a th' ort", l2: "what's your name", level: "Phrases 2"},
{l1: "cailean", l2: "Colin", level: "Phrases 2"},
{l1: "beathag", l2: "Beth", level: "Phrases 2"},
{l1: "raonaid", l2: "Rachel", level: "Phrases 2"},
{l1: "ainm", l2: "Name", level: "Phrases 2"},
{l1: "Dòmhnall", l2: "Donald", level: "Phrases 2"},
{l1: "cuideachd", l2: "Also", level: "Phrases 2"},
{l1: "obh obh", l2: "oh no", level: "Phrases 2"},
{l1: "runrig", l2: "Runrig", level: "Phrases 2"},
{l1: "an t-uisge", l2: "the rain", level: "Rain etc."},
{l1: "sneachd", l2: "Snow", level: "Rain etc."},
{l1: "reòthadh", l2: "ice", level: "Rain etc."},
{l1: "ach", l2: "But", level: "Rain etc."},
{l1: "dealanaich", l2: "lightning", level: "Rain etc."},
{l1: "tàirneanaich", l2: "thunder", level: "Rain etc."},
{l1: "fhathast", l2: "still", level: "Rain etc."},
{l1: "no", l2: "or", level: "Rain etc."},
{l1: "an-dràsta", l2: "right now", level: "Rain etc."},
{l1: "an-diugh", l2: "today", level: "Rain etc."},
{l1: "cò ris a tha an t-sìde coltach", l2: "What is the weather like", level: "Rain etc."},
{l1: "aon chù", l2: "one dog", level: "Numbers"},
{l1: "bàta", l2: "boat", level: "Numbers"},
{l1: "aon bhàta", l2: "one boat", level: "Numbers"},
{l1: "aon chàr", l2: "one car", level: "Numbers"},
{l1: "bus", l2: "bus", level: "Numbers"},
{l1: "aon bhus", l2: "one bus", level: "Numbers"},
{l1: "càr", l2: "car", level: "Numbers"},
{l1: "aon", l2: "one", level: "Numbers"},
{l1: "cia mheud", l2: "how many", level: "Numbers"},
{l1: "asal", l2: "donkey", level: "Numbers"},
{l1: "eala", l2: "Swan", level: "Numbers"},
{l1: "uinneag", l2: "Window", level: "Numbers"},
{l1: "dà", l2: "two", level: "Numbers"},
{l1: "òran", l2: "a song", level: "Numbers"},
{l1: "dà chàr", l2: "Two cars", level: "Numbers"},
{l1: "dà bhus", l2: "Two buses", level: "Numbers"},
{l1: "dà mhuc", l2: "Two pigs", level: "Numbers"},
{l1: "dà phiseag", l2: "two kittens", level: "Numbers"},
{l1: "dà chù", l2: "Two dogs", level: "Numbers"},
{l1: "dà chat", l2: "Two cats", level: "Numbers"},
{l1: "bràthair", l2: "brother", level: "Family"},
{l1: "aon bhràthair", l2: "one brother", level: "Family"},
{l1: "bràithrean", l2: "Brothers", level: "Family"},
{l1: "piuthar", l2: "sister", level: "Family"},
{l1: "aon phiuthar", l2: "one sister", level: "Family"},
{l1: "seanair", l2: "grandfather", level: "Family"},
{l1: "athair", l2: "father", level: "Family"},
{l1: "mac", l2: "son", level: "Family"},
{l1: "teaghlach", l2: "family", level: "Family"},
{l1: "leanabh", l2: "a child", level: "Family"},
{l1: "peathraichean", l2: "Sisters", level: "Family"},
{l1: "bean", l2: "Wife", level: "Family"},
{l1: "seanmhair", l2: "grandmother", level: "Family"},
{l1: "nighean", l2: "daughter", level: "Family"},
{l1: "màthair", l2: "mother", level: "Family"},
{l1: "ainmeil", l2: "famous", level: "Family"},
{l1: "antaidh", l2: "Aunt", level: "Family"},
{l1: "uncail", l2: "uncle", level: "Family"},
{l1: "an duine agam", l2: "my husband", level: "Family"},
{l1: "againn", l2: "at us", level: "Family"},
{l1: "clann", l2: "children", level: "Family"},
{l1: "luath", l2: "quick", level: "Family"},
{l1: "reamhar", l2: "fat", level: "Family"},
{l1: "onarach", l2: "honest", level: "Family"},
{l1: "sgriosail", l2: "horrible", level: "Family"},
{l1: "laghach", l2: "nice", level: "Family"},
{l1: "neònach", l2: "weird", level: "Family"},
{l1: "leabhar", l2: "a book", level: "Numbers 2"},
{l1: "rathad", l2: "Road", level: "Numbers 2"},
{l1: "sgian", l2: "a knife", level: "Numbers 2"},
{l1: "sgillinn", l2: "a penny", level: "Numbers 2"},
{l1: "stais", l2: "moustache", level: "Numbers 2"},
{l1: "latha", l2: "day", level: "Numbers 2"},
{l1: "smiogaid", l2: "chin", level: "Numbers 2"},
{l1: "not", l2: "pound", level: "Numbers 2"},
{l1: "trì", l2: "three", level: "Numbers 2"},
{l1: "ceithir", l2: "four", level: "Numbers 2"},
{l1: "còig", l2: "five", level: "Numbers 2"},
{l1: "sia", l2: "six", level: "Numbers 2"},
{l1: "bàtaichean", l2: "boats", level: "Numbers 2"},
{l1: "mucan", l2: "pigs", level: "Numbers 2"},
{l1: "piseagan", l2: "kittens", level: "Numbers 2"},
{l1: "seachd", l2: "seven", level: "Numbers 2"},
{l1: "ochd", l2: "eight", level: "Numbers 2"},
{l1: "naoi", l2: "nine", level: "Numbers 2"},
{l1: "deich", l2: "ten", level: "Numbers 2"},
{l1: "coin", l2: "dogs", level: "Numbers 2"},
{l1: "cait", l2: "cats", level: "Numbers 2"},
{l1: "a' faighinn", l2: "getting", level: "Numbers 2"},
{l1: "sùgh", l2: "juice", level: "Food 2"},
{l1: "leann", l2: "beer", level: "Food 2"},
{l1: "sùbh-làir", l2: "strawberry", level: "Food 2"},
{l1: "uachdar", l2: "cream", level: "Food 2"},
{l1: "suiteas", l2: "sweeties", level: "Food 2"},
{l1: "fìon", l2: "Wine", level: "Food 2"},
{l1: "mions", l2: "mini", level: "Food 2"},
{l1: "botal", l2: "bottle", level: "Food 2"},
{l1: "brot", l2: "soup", level: "Food 2"},
{l1: "paidh", l2: "pie", level: "Food 2"},
{l1: "ubhal", l2: "apple", level: "Food 2"},
{l1: "orainsear", l2: "orange", level: "Food 2"},
{l1: "isbean", l2: "sausage", level: "Food 2"},
{l1: "aran", l2: "bread", level: "Food 2"},
{l1: "ìm", l2: "butter", level: "Food 2"},
{l1: "bu toil leam", l2: "i would like", level: "Food 2"},
{l1: "ag ithe", l2: "eating", level: "Food 2"},
{l1: "snèap", l2: "turnip", level: "Food 2"},
{l1: "reòiteag", l2: "ice cream", level: "Food 2"},
{l1: "biadh", l2: "Food", level: "Food 2"},
{l1: "ugh", l2: "an egg", level: "Food 2"},
{l1: "ag òl", l2: "drinking", level: "Food 2"},
{l1: "cha bu toil leam", l2: "i wouldn't like", level: "Food 2"},
{l1: "glè bhlasta", l2: "very tasty", level: "Food 2"},
{l1: "tomàto", l2: "tomato", level: "Food 2"},
{l1: "uinnean", l2: "onion", level: "Food 2"},
{l1: "curran", l2: "carrot", level: "Food 2"},
{l1: "òl", l2: "drink", level: "Food 2"},
{l1: "aig", l2: "at", level: "Colors"},
{l1: "geal", l2: "White", level: "Colors"},
{l1: "dubh", l2: "black", level: "Colors"},
{l1: "orains", l2: "Orange", level: "Colors"},
{l1: "purpaidh", l2: "purple", level: "Colors"},
{l1: "ùr", l2: "new", level: "Colors"},
{l1: "e", l2: "he", level: "Colors"},
{l1: "pinc", l2: "pink", level: "Colors"},
{l1: "dearg", l2: "Red", level: "Colors"},
{l1: "gorm", l2: "blue", level: "Colors"},
{l1: "feumaidh mi", l2: "I need", level: "Colors"},
{l1: "feumaidh tu", l2: "You need", level: "Colors"},
{l1: "buidhe", l2: "yellow", level: "Colors"},
{l1: "glas", l2: "Gray", level: "Colors"},
{l1: "uaine", l2: "green", level: "Colors"},
{l1: "donn", l2: "Brown", level: "Colors"},
{l1: "liath", l2: "gray", level: "Colors"},
{l1: "briogais ghoirid", l2: "Short trousers", level: "Colors"},
{l1: "putan", l2: "button", level: "Colors"},
{l1: "goirid", l2: "short", level: "Colors"},
{l1: "gu leòr", l2: "enough", level: "Colors"},
{l1: "fada", l2: "long", level: "Colors"},
{l1: "a' dèanamh", l2: "doing", level: "Colors"},
{l1: "crios", l2: "belt", level: "Colors"},
{l1: "a' goid", l2: "stealing", level: "Colors"},
{l1: "a' cumail", l2: "keeps", level: "Colors"},
{l1: "deise", l2: "suit", level: "Colors"},
{l1: "eile", l2: "else", level: "Colors"},
{l1: "taigh", l2: "house", level: "Home"},
{l1: "gàrradh", l2: "garden", level: "Home"},
{l1: "coimpiutair", l2: "computer", level: "Home"},
{l1: "an toil leat", l2: "do you like", level: "Home"},
{l1: "deasg", l2: "desk", level: "Home"},
{l1: "iuchair", l2: "Key", level: "Home"},
{l1: "flat", l2: "flat", level: "Home"},
{l1: "bòrd", l2: "table", level: "Home"},
{l1: "preas", l2: "cupboard", level: "Home"},
{l1: "mapa", l2: "Map", level: "Home"},
{l1: "dealbh", l2: "picture", level: "Home"},
{l1: "soitheach", l2: "plate", level: "Home"},
{l1: "amar", l2: "bath", level: "Home"},
{l1: "eadar-lìon", l2: "Internet", level: "Home"},
{l1: "òrd", l2: "hammer", level: "Home"},
{l1: "aca", l2: "at them", level: "Home"},
{l1: "seòmar-cadail", l2: "bedroom", level: "Home"},
{l1: "sin", l2: "that", level: "Home"},
{l1: "aige", l2: "at him", level: "Home"},
{l1: "taigh-beag", l2: "toilet", level: "Home"},
{l1: "frids", l2: "fridge", level: "Home"},
{l1: "balla", l2: "wall", level: "Home"},
{l1: "seo", l2: "this", level: "Home"},
{l1: "càit a bheil", l2: "where is", level: "Home"},
{l1: "an toil leibh", l2: "do you (formal) like", level: "Home"},
{l1: "leabaidh", l2: "bed", level: "Home"},
{l1: "teine", l2: "fire", level: "Home"},
{l1: "doras", l2: "door", level: "Home"},
{l1: "aice", l2: "at her", level: "Home"},
{l1: "ann an", level: "About Me 2", l2: "in"},
{l1: "ag obair", level: "About Me 2", l2: "working"},
{l1: "dùn dè", level: "About Me 2", l2: "Dundee"},
{l1: "Sruighlea", level: "About Me 2", l2: "Stirling"},
{l1: "Sealtainn", level: "About Me 2", l2: "Shetland"},
{l1: "sgoil", level: "About Me 2", l2: "school"},
{l1: "obair", level: "About Me 2", l2: "work"},
{l1: "a' fuireach", level: "About Me 2", l2: "living"},
{l1: "Obar dheathain", level: "About Me 2", l2: "Aberdeen"},
{l1: "Arcaibh", level: "About Me 2", l2: "Orkney"},
{l1: "glè mhòr", level: "About Me 2", l2: "very big"},
{l1: "ospadal", level: "About Me 2", l2: "hospital"},
{l1: "oilthigh", level: "About Me 2", l2: "University"},
{l1: "Inbhir àir", level: "About Me 2", l2: "Ayr"},
{l1: "Peairt", level: "About Me 2", l2: "Perth"},
{l1: "Port rìgh", level: "About Me 2", l2: "Portree"},
{l1: "muga", level: "About Me 2", l2: "mug"},
{l1: "baile", level: "About Me 2", l2: "town"},
{l1: "Fìobha", level: "About Me 2", l2: "Fife"},
{l1: "Astràilia", level: "About Me 2", l2: "Australia"},
{l1: "Afraga a deas", level: "About Me 2", l2: "South Africa"},
{l1: "Nirribhidh", level: "About Me 2", l2: "Norway"},
{l1: "an seo", level: "About Me 2", l2: "here"},
{l1: "an sin", level: "About Me 2", l2: "there"},
{l1: "Sealainn nuadh", level: "About Me 2", l2: "New Zealand"},
{l1: "Iapan", level: "About Me 2", l2: "Japan"},
{l1: "aice", level: "About Me 2", l2: "at her"},
{l1: "Uibhist", level: "About Me 2", l2: "Uist"},
{l1: "bùth", level: "About Me 2", l2: "Shop"},
{l1: "oifis", level: "About Me 2", l2: "office"},
{l1: "margadh", level: "About Me 2", l2: "Market"},
{l1: "taigh-òsta", level: "About Me 2", l2: "Hotel"},
{l1: "Tiriodh", level: "About Me 2", l2: "Tiree"},
{l1: "meal do naidheachd", level: "Phrases 3", l2: "Congratulations"},
{l1: "deoch", level: "Phrases 3", l2: "Drink"},
{l1: "ist", level: "Phrases 3", l2: "shush"},
{l1: "tha gàidhlig agam", level: "Phrases 3", l2: "I have Gaelic"},
{l1: "a bheil gàidhlig agad", level: "Phrases 3", l2: "Do you speak Gaelic"},
{l1: "tha beagan gàidhlig agam", level: "Phrases 3", l2: "I have some Gaelic"},
{l1: "tha fios agam", level: "Phrases 3", l2: "I know"},
{l1: "chan eil fios agam", level: "Phrases 3", l2: "I do not know"},
{l1: "sibh", level: "Phrases 3", l2: "you (pl, formal)"},
{l1: "chì mi a-rithist thu", level: "Phrases 3", l2: "i'll see you again"},
{l1: "a h-uile duine", level: "Phrases 3", l2: "Everyone"},
{l1: "thig a-steach", level: "Phrases 3", l2: "come in"},
{l1: "m' eudail", level: "Phrases 3", l2: "my dear"},
{l1: "chì", level: "Phrases 3", l2: "can see"},
{l1: "agaibh", level: "Phrases 3", l2: "at you (pl)"},
{l1: "mealaibh ur naidheachd", level: "Phrases 3", l2: "congratulations (pl, formal)"},
{l1: "eairdsidh", level: "Phrases 3", l2: "Archie"},
{l1: "oighrig", level: "Phrases 3", l2: "Effie"},
{l1: "a' bruidhinn", level: "Phrases 3", l2: "speaking"},
{l1: "ag ionnsachadh", level: "Phrases 3", l2: "learning"},
{l1: "falt", level: "Body", l2: "hair"},
{l1: "beul", level: "Body", l2: "mouth"},
{l1: "broilleach", level: "Body", l2: "chest"},
{l1: "maol", level: "Body", l2: "bald"},
{l1: "grànda", level: "Body", l2: "ugly"},
{l1: "ceann", level: "Body", l2: "head"},
{l1: "aodann", level: "Body", l2: "face"},
{l1: "tinn", level: "Body", l2: "ill"},
{l1: "goirt", level: "Body", l2: "sore"},
{l1: "fallain", level: "Body", l2: "healthy"},
{l1: "làmh", level: "Body", l2: "hand"},
{l1: "cluas", level: "Body", l2: "ear"},
{l1: "sùil", level: "Body", l2: "eye"},
{l1: "sròn", level: "Body", l2: "nose"},
{l1: "duine", level: "Body", l2: "man, person"},
{l1: "goirid", level: "Body", l2: "short"},
{l1: "druim", level: "Body", l2: "back"},
{l1: "caol", level: "Body", l2: "narrow"},
{l1: "cas", level: "Body", l2: "steep"},
{l1: "teanga", level: "Body", l2: "tongue"},
{l1: "falt liath", level: "Body", l2: "gray hair"},
{l1: "falt ruadh", level: "Body", l2: "red hair"},
{l1: "falt bàn", level: "Body", l2: "blond hair"},
{l1: "glan", level: "Body", l2: "clean"},
{l1: "salach", level: "Body", l2: "dirty"},
{l1: "air", level: "Body", l2: "on"},
{l1: "oirre", level: "Body", l2: "on her"},
{l1: "dubh", level: "Animals", l2: "black"},
{l1: "ialtag", level: "Animals", l2: "bat"},
{l1: "staidhre", level: "Animals", l2: "Staircase"},
{l1: "eaglais", level: "Animals", l2: "church"},
{l1: "nathair", level: "Animals", l2: "a snake"},
{l1: "rèis", level: "Animals", l2: "race"},
{l1: "bò", level: "Animals", l2: "a cow"},
{l1: "grian", level: "Animals", l2: "sun"},
{l1: "caileag", level: "Animals", l2: "girl"},
{l1: "bean", level: "Animals", l2: "Wife"},
{l1: "piuthar", level: "Animals", l2: "sister"},
{l1: "gàidhlig", level: "Animals", l2: "Gaelic"},
{l1: "clach", level: "Animals", l2: "a stone"},
{l1: "fiacaill", level: "Animals", l2: "tooth"},
{l1: "feòrag", level: "Animals", l2: "Squirrel"},
{l1: "feannag", level: "Animals", l2: "crow"},
{l1: "crùbag", level: "Animals", l2: "crab"},
{l1: "fuil", level: "Animals", l2: "Blood"},
{l1: "sràid", level: "Animals", l2: "street"},
{l1: "sìde", level: "Animals", l2: "Weather"},
{l1: "slige", level: "Animals", l2: "a shell"},
{l1: "ceart", level: "Names", l2: "right"},
{l1: "ceàrr", level: "Names", l2: "wrong"},
{l1: "Catrìona", level: "Names", l2: "Catriona"},
{l1: "coibhneil", level: "Names", l2: "kind"},
{l1: "càirdeil", level: "Names", l2: "friendly"},
{l1: "Eubha", level: "Names", l2: "Eve"},
{l1: "Mairead", level: "Names", l2: "Margaret"},
{l1: "inntinneach", level: "Names", l2: "interesting"},
{l1: "annasach", level: "Names", l2: "unusual"},
{l1: "Ealasaid", level: "Names", l2: "Elizabeth"},
{l1: "Leagsaidh", level: "Names", l2: "Lexy"},
{l1: "Flòraidh", level: "Names", l2: "Flora"},
{l1: "pòsta", level: "Names", l2: "married"},
{l1: "còmhla ri", level: "Hobbies", l2: "along with"},
{l1: "a' leughadh", level: "Hobbies", l2: "reading"},
{l1: "a' sgrìobhadh", level: "Hobbies", l2: "writing"},
{l1: "faisg air", level: "Hobbies", l2: "close to"},
{l1: "an-dè", level: "Hobbies", l2: "yesterday"},
{l1: "litir", level: "Hobbies", l2: "letter"},
{l1: "a' coiseachd", level: "Hobbies", l2: "walking"},
{l1: "a' ruith", level: "Hobbies", l2: "running"},
{l1: "leabharlann", level: "Hobbies", l2: "library"},
{l1: "a-raoir", level: "Hobbies", l2: "last night"},
{l1: "a' snàmh", level: "Hobbies", l2: "swimming"},
{l1: "a' cadal", level: "Hobbies", l2: "sleeping"},
{l1: "a-riamh", level: "Hobbies", l2: "ever"},
{l1: "a' dol", level: "Hobbies", l2: "going"},
{l1: "feasgar an-dè", level: "Hobbies", l2: "yesterday afternoon"},
{l1: "madainn an-dè", level: "Hobbies", l2: "yesterday morning"},
{l1: "a' seinn", level: "Hobbies", l2: "Singing"},
{l1: "a' sreap", level: "Hobbies", l2: "climbing"},
{l1: "màrtainn", level: "Hobbies", l2: "Martin"},
{l1: "tuathanas", level: "Hobbies", l2: "farm"},
{l1: "drochaid", level: "Hobbies", l2: "bridge"},
{l1: "còmhla", level: "Hobbies", l2: "together"},
{l1: "a' tighinn", level: "Travel", l2: "coming"},
{l1: "trèana", level: "Travel", l2: "Train"},
{l1: "plèana", level: "Travel", l2: "plane"},
{l1: "bus", level: "Travel", l2: "bus"},
{l1: "stèisean", level: "Travel", l2: "station"},
{l1: "trèanaichean", level: "Travel", l2: "railways"},
{l1: "busaichean", level: "Travel", l2: "buses"},
{l1: "bàta", level: "Travel", l2: "boat"},
{l1: "càr", level: "Travel", l2: "car"},
{l1: "a' falbh", level: "Travel", l2: "leaving"},
{l1: "daor", level: "Travel", l2: "expensive"},
{l1: "saor", level: "Travel", l2: "cheap"},
{l1: "dìreach", level: "Travel", l2: "just"},
{l1: "falbh", level: "Travel", l2: "leave"},
{l1: "eilean", level: "Travel", l2: "island"},
{l1: "uinneag", level: "Travel", l2: "Window"},
{l1: "stad", level: "Travel", l2: "stop"},
{l1: "tiogaid", level: "Travel", l2: "ticket"},
{l1: "airgead", level: "Travel", l2: "Money"},
{l1: "seall air", level: "Travel", l2: "Look at"},
{l1: "fosgailte", level: "Travel", l2: "open"},
{l1: "dùinte", level: "Travel", l2: "closed"},
{l1: "an t-eilean sgitheanach", level: "Travel", l2: "Isle of Skye"},
{l1: "a' draibheadh", level: "Travel", l2: "driving"},
{l1: "cudromach", level: "Names 2", l2: "important"},
{l1: "bochd", level: "Names 2", l2: "poor"},
{l1: "a sheumais", level: "Names 2", l2: "james (vocative)"},
{l1: "a chaluim", level: "Names 2", l2: "Calum (vocative)"},
{l1: "a phàdraig", level: "Names 2", l2: "Patrick (vocative)"},
{l1: "a thormoid", level: "Names 2", l2: "Norman (vocative)"},
{l1: "Tormod", level: "Names 2", l2: "Norman"},
{l1: "Pàdraig", level: "Names 2", l2: "Peter"},
{l1: "Uilleam", level: "Names 2", l2: "William"},
{l1: "Uilleim", level: "Names 2", l2: "William (vocative)"},
{l1: "Aonghas", level: "Names 2", l2: "Angus"},
{l1: "Aonghais", level: "Names 2", l2: "Angus (vocative)"},
{l1: "Eòghann", level: "Names 2", l2: "Ewan"},
{l1: "Eòghainn", level: "Names 2", l2: "Ewan (vocative)"},
{l1: "Ruairidh", level: "Names 2", l2: "Rory"},
{l1: "a ruairidh", level: "Names 2", l2: "Rory (vocative)"},
{l1: "Niall", level: "Names 2", l2: "Neil"},
{l1: "slaodach", level: "Names 2", l2: "slow"},
{l1: "a nèill", level: "Names 2", l2: "Neil (vocative)"},
{l1: "Fionnlagh", level: "Names 2", l2: "Finlay"},
{l1: "Fhionnlaigh", level: "Names 2", l2: "Finlay (vocative)"},
{l1: "Frìseal", level: "Names 2", l2: "Fraser"},
{l1: "a fhrìseil", level: "Names 2", l2: "Fraser (vocative)"},
{l1: "glic", level: "Names 2", l2: "wise"},
{l1: "Fearghas", level: "Names 2", l2: "Fergus"},
{l1: "Fhearghais", level: "Names 2", l2: "Fergus (vocative)"},
{l1: "greas ort", level: "Feelings 2", l2: "hurry up"},
{l1: "mise", level: "Feelings 2", l2: "me (emphatic)"},
{l1: "bòidheach", level: "Feelings 2", l2: "beautiful"},
{l1: "làidir", level: "Feelings 2", l2: "strong"},
{l1: "lag", level: "Feelings 2", l2: "weak"},
{l1: "acras", level: "Feelings 2", l2: "hunger"},
{l1: "eagal", level: "Feelings 2", l2: "fear"},
{l1: "oirnn", level: "Feelings 2", l2: "on us"},
{l1: "thusa", level: "Feelings 2", l2: "you (emphatic)"},
{l1: "uabhasach", level: "Feelings 2", l2: "terrible"},
{l1: "sibhse", level: "Feelings 2", l2: "you (pl, formal, emphatic)"},
{l1: "pathadh", level: "Feelings 2", l2: "thirst"},
{l1: "fearg", level: "Feelings 2", l2: "anger"},
{l1: "esan", level: "Feelings 2", l2: "he (emphatic)"},
{l1: "dragh", level: "Feelings 2", l2: "worry"},
{l1: "ise", level: "Feelings 2", l2: "she (emphatic)"},
{l1: "cabhag", level: "Feelings 2", l2: "hurry"},
{l1: "cnatan", level: "Feelings 2", l2: "flu"},
{l1: "orra", level: "Feelings 2", l2: "on them"},
{l1: "oirbh", level: "Feelings 2", l2: "on you (plural)"},
{l1: "an dèideadh", level: "an dèideadh", l2: "toothache"},
{l1: "mìcheal", level: "Feelings 2", l2: "Michael"},
{l1: "gaol", level: "Feelings 2", l2: "love"},
{l1: "gràin", level: "Feelings 2", l2: "hate"},
{l1: "A' chuimrigh", level: "Countries", l2: "Wales"},
{l1: "A' ghearmailt", level: "Countries", l2: "Germany"},
{l1: "Eilean mhanainn", level: "Countries", l2: "Isle of Man"},
{l1: "A' phòlainn", level: "Countries", l2: "Poland"},
{l1: "a' phìob-mhòr", level: "Countries", l2: "Bagpipes"},
{l1: "Innis tìle", level: "Countries", l2: "Iceland"},
{l1: "ceòl", level: "Countries", l2: "Music"},
{l1: "A' bheilg", level: "Countries", l2: "Belgium"},
{l1: "A' phortagail", level: "Countries", l2: "Portugal"},
{l1: "ro", level: "Countries", l2: "before"},
{l1: "clann", level: "Countries", l2: "children"},
{l1: "craobh", level: "Countries", l2: "tree"},
{l1: "a' ghrèig", level: "Countries", l2: "Greece"},
{l1: "An roinn-eòrpa", level: "Countries", l2: "Europe"},
{l1: "An spàinn", level: "Countries", l2: "Spain"},
{l1: "An rìoghachd aonaichte", level: "Countries", l2: "United Kingdom"},
{l1: "An ruis", level: "Countries", l2: "Russia"},
{l1: "An tuirc", level: "Countries", l2: "Turkey"},
{l1: "rathad", level: "Countries", l2: "Road"},
{l1: "An fhraing", level: "Countries", l2: "France"},
{l1: "An t-suain", level: "Countries", l2: "Sweden"},
{l1: "A' chòrn", level: "Countries", l2: "Cornwall"},
{l1: "Breatainn", level: "Countries", l2: "Britain"},
{l1: "fidheall", level: "Countries", l2: "fiddle"},
{l1: "fionnlann", level: "Countries", l2: "Finland"},
{l1: "seacaid", level: "Countries", l2: "jacket"},
{l1: "An eadailt", level: "Countries", l2: "Italy"},
{l1: "An ostair", level: "Countries", l2: "Austria"},
{l1: "An eilbheis", level: "Countries", l2: "Switzerland"},
{l1: "Sìona", level: "Countries", l2: "China"},
{l1: "A' bhreatann bheag", level: "Countries", l2: "Brittany"},
{l1: "abhainn", level: "Countries", l2: "river"},
{l1: "a-staigh", level: "Pets 2", l2: "inside"},
{l1: "niseag", level: "Pets 2", l2: "Nessy"},
{l1: "cat", level: "Pets 2", l2: "cat"},
{l1: "peata", level: "Pets 2", l2: "pet"},
{l1: "pàirc", level: "Pets 2", l2: "Park"},
{l1: "cù", level: "Pets 2", l2: "dog"},
{l1: "eagalach", level: "Pets 2", l2: "scary"},
{l1: "each", level: "Pets 2", l2: "horse"},
{l1: "radan", level: "Pets 2", l2: "rat"},
{l1: "baga", level: "Pets 2", l2: "bag"},
{l1: "a-mach", level: "Pets 2", l2: "outside"},
{l1: "bìodach", level: "Pets 2", l2: "tiny"},
{l1: "feumail", level: "Pets 2", l2: "helpful"},
{l1: "coineanach", level: "Pets 2", l2: "Rabbit"},
{l1: "a-steach", level: "Pets 2", l2: "inwards"},
{l1: "mathan", level: "Pets 2", l2: "bear"},
{l1: "tarbh", level: "Pets 2", l2: "a bull"},
{l1: "broc", level: "Pets 2", l2: "badger"},
{l1: "gleann", level: "Pets 2", l2: "glen"},
{l1: "caora", level: "Pets 2", l2: "a sheep"},
{l1: "eun", level: "Pets 2", l2: "a bird"},
{l1: "iasg", level: "Pets 2", l2: "fish"},
{l1: "coille", level: "Pets 2", l2: "forest"},
{l1: "sligeanach", level: "Pets 2", l2: "tortoise"},
{l1: "dìleas", level: "Pets 2", l2: "loyal"},
{l1: "loch", level: "Pets 2", l2: "loch"},
{l1: "èirisgeidh", level: "Pets 2", l2: "Eriskay"},
{l1: "a' leum", level: "Pets 2", l2: "jumping"},
{l1: "gràineag", level: "Pets 2", l2: "hedgehog"},
{l1: "leòmhann", level: "Pets 2", l2: "lion"},
{l1: "feur", level: "Pets 2", l2: "Grass"},
{l1: "mo", level: "Body 2", l2: "my"},
{l1: "do", level: "Body 2", l2: "your"},
{l1: "coltach ri", level: "Body 2", l2: "similar to"},
{l1: "a' coimhead", level: "Body 2", l2: "looking"},
{l1: "sean", level: "Body 2", l2: "old"},
{l1: "stamag", level: "Body 2", l2: "stomach"},
{l1: "tòn", level: "Body 2", l2: "bottom"},
{l1: "sàbhailte", level: "Body 2", l2: "Safe"},
{l1: "glùn", level: "Body 2", l2: "knee"},
{l1: "bodhaig", level: "Body 2", l2: "body"},
{l1: "gàirdean", level: "Body 2", l2: "arm"},
{l1: "eadar", level: "Body 2", l2: "between"},
{l1: "ag èisteachd", level: "Body 2", l2: "Listening"},
{l1: "briste", level: "Body 2", l2: "broken"},
{l1: "amhach", level: "Body 2", l2: "neck"},
{l1: "a' dannsa", level: "Body 2", l2: "Dancing"},
{l1: "corrag", level: "Body 2", l2: "finger"},
{l1: "gleansach", level: "Body 2", l2: "shiny"},
{l1: "bàn", level: "Body 2", l2: "fair"},
{l1: "ruadh", level: "Body 2", l2: "ruadh, ginger"},
{l1: "cugallach", level: "Body 2", l2: "fragile"},
{l1: "diluain", level: "Days", l2: "Monday"},
{l1: "dimàirt", level: "Days", l2: "Tuesday"},
{l1: "a' sgioblachadh", level: "Days", l2: "tidying"},
{l1: "aon-deug", level: "Days", l2: "eleven"},
{l1: "dà-dheug", level: "Days", l2: "twelve"},
{l1: "seachd", level: "Days", l2: "seven"},
{l1: "diciadain", level: "Days", l2: "Wednesday"},
{l1: "diardaoin", level: "Days", l2: "Thursday"},
{l1: "trì-deug", level: "Days", l2: "thirteen"},
{l1: "ceithir-deug", level: "Days", l2: "fourteen"},
{l1: "còig-deug", level: "Days", l2: "fifteen"},
{l1: "ag èigheachd", level: "Days", l2: "shouting"},
{l1: "ochd", level: "Days", l2: "eight"},
{l1: "dihaoine", level: "Days", l2: "Friday"},
{l1: "disathairne", level: "Days", l2: "Saturday"},
{l1: "sia-deug", level: "Days", l2: "sixteen"},
{l1: "seachd-deug", level: "Days", l2: "seventeen"},
{l1: "ochd-deug", level: "Days", l2: "eighteen"},
{l1: "a-màireach", level: "Days", l2: "tomorrow"},
{l1: "a' feuchainn", level: "Days", l2: "trying"},
{l1: "Didòmhnaich", level: "Days", l2: "Sunday"},
{l1: "latha na sàbaid", level: "Days", l2: "Sunday (sabbath)"},
{l1: "naoi-deug", level: "Days", l2: "nineteen"},
{l1: "fichead", level: "Days", l2: "twenty"},
{l1: "a' togail", level: "Days", l2: "Building"},
{l1: "sinne", level: "Days", l2: "we (emphatic)"},
{l1: "a-nochd", level: "Days", l2: "tonight"},
{l1: "iadsan", level: "Days", l2: "they (emphatic)"},
{l1: "a dh'aithghearr", level: "Days", l2: "Soon"},
{l1: "air ais", level: "Days", l2: "Back"},
{l1: "na hearadh", level: "Days", l2: "Harris"},
{l1: "sàmhach", level: "Days", l2: "quiet"},
{l1: "seachdain", level: "Days", l2: "week"},
{l1: "a' coinneachadh", level: "Family 2", l2: "Meeting"},
{l1: "cuideachail", level: "Family 2", l2: "helpful"},
{l1: "bràthair", level: "Family 2", l2: "brother"},
{l1: "pàrant", level: "Family 2", l2: "Parent"},
{l1: "facal", level: "Family 2", l2: "Word"},
{l1: "faclair", level: "Family 2", l2: "Dictionary"},
{l1: "caraid", level: "Family 2", l2: "friend"},
{l1: "spaideil", level: "Family 2", l2: "fancy"},
{l1: "teaghlach", level: "Family 2", l2: "family"},
{l1: "modhail", level: "Family 2", l2: "polite"},
{l1: "an duine agad", level: "Family 2", l2: "Your husband"},
{l1: "co-ogha", level: "Family 2", l2: "cousin"},
{l1: "mìorbhaileach", level: "Family 2", l2: "marvellous"},
{l1: "mì-mhodhail", level: "Family 2", l2: "impolite"},
{l1: "seada", level: "Family 2", l2: "shed"},
{l1: "mo chreach", level: "Family 2", l2: "oh goodness"},
{l1: "dhachaigh", level: "Family 2", l2: "home"},
{l1: "mac", level: "Family 2", l2: "son"},
{l1: "athair", level: "Family 2", l2: "father"},
{l1: "nighean", level: "Family 2", l2: "daughter"},
{l1: "doileag", level: "Family 2", l2: "doll"},
{l1: "seanair", level: "Family 2", l2: "grandfather"},
{l1: "thalla", level: "Family 2", l2: "go away"},
{l1: "seanmhair", level: "Family 2", l2: "grandmother"},
{l1: "beurla", level: "Family 2", l2: "English"},
{l1: "dèideag", level: "Family 2", l2: "toy"},
{l1: "taigh-seinnse", level: "Family 2", l2: "pub"},
{l1: "ball-coise", level: "Sport", l2: "football"},
{l1: "iomain", level: "Sport", l2: "shinty"},
{l1: "a h-uile", level: "Sport", l2: "every"},
{l1: "goilf", level: "Sport", l2: "golf"},
{l1: "geama", level: "Sport", l2: "game"},
{l1: "ball", level: "Sport", l2: "ball"},
{l1: "cunnartach", level: "Sport", l2: "dangerous"},
{l1: "math air", level: "Sport", l2: "good at"},
{l1: "rothair", level: "Sport", l2: "bike"},
{l1: "ag iasgach", level: "Sport", l2: "Fishing"},
{l1: "deiseil", level: "Sport", l2: "ready"},
{l1: "a' cluiche", level: "Sport", l2: "Playing"},
{l1: "tràigh", level: "Sport", l2: "beach"},
{l1: "teanas", level: "Sport", l2: "tennis"},
{l1: "a' seòladh", level: "Sport", l2: "sailing"},
{l1: "rothaireachd", level: "Sport", l2: "cycling"},
{l1: "rugbaidh", level: "Sport", l2: "rugby"},
{l1: "an gearasdan", level: "Sport", l2: "Fort William"},
{l1: "còmhla ri chèile", level: "Sport", l2: "together with each other"},
{l1: "ball-basgaid", level: "Sport", l2: "Basketball"},
{l1: "uaireannan", level: "Sport", l2: "sometimes"},
{l1: "an-dràsta fhèin", level: "Sport", l2: "right now"},
{l1: "spòrs", level: "Sport", l2: "Sport"},
{l1: "furasta", level: "Sport", l2: "easy"},
{l1: "math dhut", level: "Sport", l2: "good for you"},
{l1: "dannsa gàidhealach", level: "Sport", l2: "Highland Dancing"},
{l1: "dhut", level: "Sport", l2: "to you"},
{l1: "doirbh", level: "Sport", l2: "Difficult"},
{l1: "a' ghàidhealtachd", level: "Sport", l2: "The Highlands"},
{l1: "a' sgitheadh", level: "Sport", l2: "skiing"},
{l1: "a' ghalldachd", level: "Sport", l2: "The Lowlands"},
{l1: "an uairsin", level: "Sport", l2: "then"},
{l1: "rèidio", level: "Sport", l2: "Radio"},
{l1: "telebhisean", level: "Sport", l2: "Television"},
{l1: "milis", level: "Food 3", l2: "sweet"},
{l1: "searbh", level: "Food 3", l2: "bitter"},
{l1: "taigh-bìdh", level: "Food 3", l2: "restaurant"},
{l1: "cidsin", level: "Food 3", l2: "kitchen"},
{l1: "seòclaid", level: "Food 3", l2: "chocolate"},
{l1: "am bu toil leat", level: "Food 3", l2: "would you like"},
{l1: "dinnear", level: "Food 3", l2: "Dinner"},
{l1: "bracaist", level: "Food 3", l2: "breakfast"},
{l1: "ith", level: "Food 3", l2: "Eat"},
{l1: "ceapaire", level: "Food 3", l2: "a sandwich"},
{l1: "cus", level: "Food 3", l2: "too much"},
{l1: "aran-milis", level: "Food 3", l2: "shortbread"},
{l1: "marag-dhubh", level: "Food 3", l2: "black pudding"},
{l1: "spìosrach", level: "Food 3", l2: "spicy"},
{l1: "gabh", level: "Food 3", l2: "take"},
{l1: "a' gabhail", level: "Food 3", l2: "taking"},
{l1: "bradan", level: "Food 3", l2: "salmon"},
{l1: "feòil", level: "Food 3", l2: "meat"},
{l1: "na ith", level: "Food 3", l2: "Never eat"},
{l1: "na gabh", level: "Food 3", l2: "Don't take"},
{l1: "measan", level: "Food 3", l2: "fruits"},
{l1: "glasraich", level: "Food 3", l2: "vegetables"},
{l1: "truinnsear", level: "Food 3", l2: "a plate"},
{l1: "is fheàrr leam", level: "Food 3", l2: "I prefer"},
{l1: "glainne", level: "Food 3", l2: "glass"},
{l1: "cupa", level: "Food 3", l2: "cup"},
{l1: "mòr-bhùth", level: "Food 3", l2: "Supermarket"},
{l1: "albannach", level: "Food 3", l2: "Scottish"},
{l1: "eadailteach", level: "Food 3", l2: "Italian"},
{l1: "sìonach", level: "Food 3", l2: "Chinese"},
{l1: "sgreamhail", level: "Food 3", l2: "disgusting"},
{l1: "seòclaid theth", level: "Food 3", l2: "hot chocolate"},
{l1: "dè an uair a tha e", level: "Time", l2: "what time is it"},
{l1: "uair", level: "Time", l2: "hour"},
{l1: "dà uair", level: "Time", l2: "two o' clock"},
{l1: "an dèidh", level: "Time", l2: "After"},
{l1: "cèilidh", level: "Time", l2: "Ceilidh"},
{l1: "partaidh", level: "Time", l2: "Party"},
{l1: "madainn an-diugh", level: "Time", l2: "this morning"},
{l1: "ma-thà", level: "Time", l2: "then (as in 'ok then')"},
{l1: "sin", level: "Time", l2: "that"},
{l1: "uairean", level: "Time", l2: "hours"},
{l1: "cloc", level: "Time", l2: "clock"},
{l1: "feasgar an-diugh", level: "Time", l2: "this afternoon"},
{l1: "boireannach", level: "Time", l2: "woman"},
{l1: "cuin", level: "Time", l2: "when"},
{l1: "feasgar a-màireach", level: "Time", l2: "tomorrow afternoon"},
{l1: "tràth", level: "Time", l2: "Early"},
{l1: "fadalach", level: "Time", l2: "late"},
{l1: "sin thu fhèin", level: "Time", l2: "there you are"},
{l1: "leth uair an dèidh", level: "Time", l2: "half past"},
{l1: "dà mhionaid", level: "Time", l2: "two minutes"},
{l1: "madainn a-màireach", level: "Time", l2: "tomorrow morning"},
{l1: "fichead 's a h-aon", level: "Time", l2: "twenty one"},
{l1: "fichead 's a dhà", level: "Time", l2: "twenty two"},
{l1: "fichead 's a...", level: "Time", l2: "twenty..."},
{l1: "aon uair deug", level: "Time", l2: "eleven o'clock"},
{l1: "cairteal an dèidh", level: "Time", l2: "a quarter after"},
{l1: "fichead 's a h-ochd", level: "Time", l2: "twenty-eight"},
{l1: "coma", level: "Time", l2: "indifferent"},
{l1: "mionaid", level: "Time", l2: "minute"},
{l1: "dà uair dheug", level: "Time", l2: "twelve o' clock"},
{l1: "cairteal gu", level: "Time", l2: "quarter to"},
{l1: "dè an aois a", level: "Time", l2: "How old..."},
{l1: "bliadhna", level: "Time", l2: "year"},
{l1: "am-bliadhna", level: "Time", l2: "this year"},
{l1: "mìos", level: "Time", l2: "month"},
{l1: "aois", level: "Time", l2: "Age"},
{l1: "turadh", level: "Weather 2", l2: "dry spell"},
{l1: "gu dearbh", level: "Weather 2", l2: "indeed"},
{l1: "tioram", level: "Weather 2", l2: "dry"},
{l1: "oidhche", level: "Weather 2", l2: "night"},
{l1: "gealach", level: "Weather 2", l2: "moon"},
{l1: "deagh", level: "Weather 2", l2: "Good"},
{l1: "soilleir", level: "Weather 2", l2: "Clear"},
{l1: "clachan-meallain", level: "Weather 2", l2: "hailstones"},
{l1: "reòite", level: "Weather 2", l2: "frozen"},
{l1: "a' fàs", level: "Weather 2", l2: "Growing"},
{l1: "caran", level: "Weather 2", l2: "somewhat"},
{l1: "dìle", level: "Weather 2", l2: "flooding"},
{l1: "droch", level: "Weather 2", l2: "bad"},
{l1: "a' cur", level: "Weather 2", l2: "putting / falling (weather)"},
{l1: "deigh", level: "Weather 2", l2: "ice"},
{l1: "bog fliuch", level: "Weather 2", l2: "soaking wet"},
{l1: "cuir", level: "Weather 2", l2: "put"},
{l1: "sgrathail", level: "Weather 2", l2: "disgraceful"},
{l1: "feasgar", level: "Weather 2", l2: "afternoon"},
{l1: "mhadainn", level: "Weather 2", l2: "morning"},
{l1: "suas", level: "Weather 2", l2: "up"},
{l1: "àite", level: "Weather 2", l2: "place"},
{l1: "latha", level: "Weather 2", l2: "day"},
{l1: "ciùin", level: "Weather 2", l2: "calm"},
{l1: "miotagan", level: "Weather 2", l2: "gloves"},
{l1: "a' mheanbh-chuileag", level: "Weather 2", l2: "the midgies"},
{l1: "sìos", level: "Weather 2", l2: "down"},
{l1: "muir", level: "Weather 2", l2: "Sea"},
{l1: "adhar", level: "Weather 2", l2: "air"},
{l1: "trom", level: "Home 2", l2: "heavy"},
{l1: "aotrom", level: "Home 2", l2: "Light"},
{l1: "seòmar", level: "Home 2", l2: "room"},
{l1: "togalach", level: "Home 2", l2: "A building"},
{l1: "forca", level: "Home 2", l2: "fork"},
{l1: "faigh", level: "Home 2", l2: "get"},
{l1: "peann", level: "Home 2", l2: "pen"},
{l1: "spàin", level: "Home 2", l2: "spoon"},
{l1: "làr", level: "Home 2", l2: "floor"},
{l1: "fada air falbh", level: "Home 2", l2: "far away"},
{l1: "na tog", level: "Home 2", l2: "Do not pick up"},
{l1: "tog", level: "Home 2", l2: "pick up"},
{l1: "flùr", level: "Home 2", l2: "flour"},
{l1: "taigh", level: "Home 2", l2: "house"},
{l1: "fear", level: "Home 2", l2: "one (masc)"},
{l1: "tè", level: "Home 2", l2: "one (fem)"},
{l1: "mòra", level: "Home 2", l2: "big (plural)"},
{l1: "beaga", level: "Home 2", l2: "small (plural)"},
{l1: "dè", level: "Home 2", l2: "what"},
{l1: "rud", level: "Home 2", l2: "thing"},
{l1: "thoir dhomh", level: "Home 2", l2: "give me"},
{l1: "ùra", level: "Home 2", l2: "new (plural)"},
{l1: "dearga", level: "Home 2", l2: "red (plural)"},
{l1: "beò", level: "Home 2", l2: "alive"},
{l1: "marbh", level: "Home 2", l2: "dead"},
{l1: "siud", level: "Home 2", l2: "that over there"},
{l1: "matha", level: "Home 2", l2: "good (plural)"},
{l1: "nurs", level: "Work", l2: "nurse"},
{l1: "dotair", level: "Work", l2: "doctor"},
{l1: "tidsear", level: "Work", l2: "Teacher"},
{l1: "glanadair", level: "Work", l2: "cleaner"},
{l1: "a' glanadh", level: "Work", l2: "cleaning"},
{l1: "poileas", level: "Work", l2: "Police"},
{l1: "a' teagasg", level: "Work", l2: "Teaching"},
{l1: "banca", level: "Work", l2: "bank"},
{l1: "ollamh", level: "Work", l2: "Professor"},
{l1: "colaiste", level: "Work", l2: "College"},
{l1: "iasgair", level: "Work", l2: "fisherman"},
{l1: "tuathanach", level: "Work", l2: "a farmer"},
{l1: "rùnaire", level: "Work", l2: "Secretary"},
{l1: "a' suidhe", level: "Work", l2: "Sitting"},
{l1: "sam bith", level: "Work", l2: "Any"},
{l1: "a' seasamh", level: "Work", l2: "Standing"},
{l1: "neach-ciùil", level: "Work", l2: "musician"},
{l1: "neach-bùtha", level: "Work", l2: "shopkeeper"},
{l1: "neach-frithealaidh", level: "Work", l2: "waitor"},
{l1: "an siud", level: "Work", l2: "over there"},
{l1: "croit", level: "Work", l2: "Croft"},
{l1: "croitear", level: "Work", l2: "crofter"},
{l1: "a' sabaid", level: "Work", l2: "fighting"},
{l1: "sagart", level: "Work", l2: "priest"},
{l1: "ministear", level: "Work", l2: "Minister"},
{l1: "neach-smàlaidh", level: "Work", l2: "firefighter"},
{l1: "feòladair", level: "Work", l2: "butcher"},
{l1: "ge-tà", level: "Work", l2: "however, though"},
{l1: "ailtire", level: "Work", l2: "An architect"},
{l1: "còcaire", level: "Work", l2: "Cook"},
{l1: "clachair", level: "Work", l2: "mason"},
{l1: "comasach", level: "Work", l2: "possible"},
{l1: "dìcheallach", level: "Work", l2: "hardworking"},
{l1: "leisg", level: "Work", l2: "lazy"},
{l1: "ceist", level: "Work", l2: "Question"},
{l1: "fad an latha", level: "Work", l2: "all day"},
{l1: "a' còcaireachd", level: "Work", l2: "Cooking"},
{l1: "is math sin", level: "Sayings", l2: "that's good"},
{l1: "làn", level: "Sayings", l2: "full"},
{l1: "falamh", level: "Sayings", l2: "empty"},
{l1: "cat-fiadhaich", level: "Sayings", l2: "wildcat"},
{l1: "seas", level: "Sayings", l2: "stand "},
{l1: "suidh", level: "Sayings", l2: "sit"},
{l1: "b' àill leibh", level: "Sayings", l2: "pardon?"},
{l1: "cathair", level: "Sayings", l2: "City"},
{l1: "leisgeadair", level: "Sayings", l2: "lazy person"},
{l1: "fiadh", level: "Sayings", l2: "deer"},
{l1: "stiall ort", level: "Sayings", l2: "on you go"},
{l1: "fileanta", level: "Sayings", l2: "fluent"},
{l1: "foighidneach", level: "Sayings", l2: "patient"},
{l1: "sgarbh", level: "Sayings", l2: "cormorant "},
{l1: "ròn", level: "Sayings", l2: "seal"},
{l1: "bodach", level: "Sayings", l2: "old man"},
{l1: "cailleach", level: "Sayings", l2: "old woman"},
{l1: "cruaidh", level: "Sayings", l2: "hard"},
{l1: "bàrd", level: "Sayings", l2: "Bard"},
{l1: "sona", level: "Sayings", l2: "happy"},
{l1: "coltach", level: "Sayings", l2: "similar"},
{l1: "rudeigin", level: "Sayings", l2: "something"},
{l1: "cuideigin", level: "Sayings", l2: "someone"},
{l1: "bog", level: "Sayings", l2: "soft"},
{l1: "iarann", level: "Sayings", l2: "iron"},
{l1: "lofa", level: "Sayings", l2: "loaf"},
{l1: "sionnach", level: "Sayings", l2: "Fox"},
{l1: "seann", level: "Sayings", l2: "old"},
{l1: "iongantach", level: "Sayings", l2: "amazing"},
{l1: "mil", level: "Sayings", l2: "honey"},
{l1: "ball iomain", level: "Sayings", l2: "shinty ball"},
{l1: "geàrr", level: "Sayings", l2: "Short"},
{l1: "seilcheig", level: "Sayings", l2: "a snail"},
{l1: "seòlta", level: "Sayings", l2: "cunning"},
{l1: "deònach", level: "Languages", l2: "willing"},
{l1: "bruidhinn", level: "Languages", l2: "Talk"},
{l1: "ceap breatainn", level: "Languages", l2: "Cape Breton"},
{l1: "fraingis", level: "Languages", l2: "French"},
{l1: "rium", level: "Languages", l2: "with me"},
{l1: "taingeil", level: "Languages", l2: "grateful"},
{l1: "èist", level: "Languages", l2: "Listen"},
{l1: "gàidhlig na h-èireann", level: "Languages", l2: "Irish Gaelic"},
{l1: "gearmailtis", level: "Languages", l2: "German"},
{l1: "cànan", level: "Languages", l2: "Language"},
{l1: "riut", level: "Languages", l2: "with you"},
{l1: "ribh", level: "Languages", l2: "with you (pl, formal)"},
{l1: "èistibh", level: "Languages", l2: "listen (pl, formal)"},
{l1: "ionnsaich", level: "Languages", l2: "Learn"},
{l1: "a’ bheurla ghallda", level: "Languages", l2: "Scots"},
{l1: "ris", level: "Languages", l2: "with him"},
{l1: "cuimris", level: "Languages", l2: "Welsh"},
{l1: "còrnais", level: "Languages", l2: "Cornish"},
{l1: "cànan soidhnidh bhreatainn", level: "Languages", l2: "British Sign Language"},
{l1: "ionnsaichibh", level: "Languages", l2: "learn (pl, formal)"},
{l1: "rithe", level: "Languages", l2: "with her"},
{l1: "càirdeach", level: "Languages", l2: "related"},
{l1: "spainntis", level: "Languages", l2: "Spanish"},
{l1: "ceilteach", level: "Languages", l2: "Celtic"},
{l1: "gàidhlig mhanainn", level: "Languages", l2: "Manx Gaelic"},
{l1: "cànan-soidhnidh aimearaga", level: "Languages", l2: "American Sign Language"},
{l1: "seòladair", level: "The Sea", l2: "sailor"},
{l1: "muc-mhara", level: "The Sea", l2: "whale"},
{l1: "hiort", level: "The Sea", l2: "St Kilda"},
{l1: "rach fodha", level: "The Sea", l2: "to sink"},
{l1: "sgileil", level: "The Sea", l2: "skilled"},
{l1: "sgiobair", level: "The Sea", l2: "skipper"},
{l1: "air bòrd", level: "The Sea", l2: "on board"},
{l1: "taigh-solais", level: "The Sea", l2: "lighthouse"},
{l1: "cuan", level: "The Sea", l2: "Ocean"},
{l1: "leumadair", level: "The Sea", l2: "dolphin"},
{l1: "tonn", level: "The Sea", l2: "wave"},
{l1: "farsaing", level: "The Sea", l2: "wide"},
{l1: "a' sgreuchail", level: "The Sea", l2: "Screaming"},
{l1: "bhatarsaigh", level: "The Sea", l2: "Vatersay"},
{l1: "cearban", level: "The Sea", l2: "shark"},
{l1: "faoileag", level: "The Sea", l2: "seagull"},
{l1: "spùinneadair-mara", level: "The Sea", l2: "pirate"},
{l1: "Malaig", level: "The Sea", l2: "Mallaig"},
{l1: "tìr", level: "The Sea", l2: "Land"},
{l1: "ratharsair", level: "The Sea", l2: "Raasay"},
{l1: "feamainn", level: "The Sea", l2: "seaweed"},
{l1: "ochd-chasach", level: "The Sea", l2: "octopus"},
{l1: "pitheid", level: "The Sea", l2: "parrot"},
{l1: "feumaidh", level: "The Sea", l2: "must"},
{l1: "ruith", level: "Hobbies 2", l2: "run"},
{l1: "sgioba", level: "Hobbies 2", l2: "team"},
{l1: "a' fighe", level: "Hobbies 2", l2: "knitting"},
{l1: "geansaidh", level: "Hobbies 2", l2: "jumper"},
{l1: "sgioblaich", level: "Hobbies 2", l2: "tidy"},
{l1: "coisich", level: "Hobbies 2", l2: "Walk"},
{l1: "taigh-dhealbh", level: "Hobbies 2", l2: "cinema"},
{l1: "cluich", level: "Hobbies 2", l2: "Play"},
{l1: "air falbh", level: "Hobbies 2", l2: "away"},
{l1: "ad", level: "Hobbies 2", l2: "hat"},
{l1: "còmhlan-ciùil", level: "Hobbies 2", l2: "Band"},
{l1: "còisir", level: "Hobbies 2", l2: "choir"},
{l1: "seinn", level: "Hobbies 2", l2: "sing"},
{l1: "ruithibh", level: "Hobbies 2", l2: "run (pl, formal)"},
{l1: "cluichibh", level: "Hobbies 2", l2: "play (pl, formal)"},
{l1: "tàileasg", level: "Hobbies 2", l2: "Chess"},
{l1: "geama-bùird", level: "Hobbies 2", l2: "board game"},
{l1: "coisichibh", level: "Hobbies 2", l2: "walk (pl, formal)"},
{l1: "pàipear-naidheachd", level: "Hobbies 2", l2: "Newspaper"},
{l1: "nobhail", level: "Hobbies 2", l2: "novel"},
{l1: "leugh", level: "Hobbies 2", l2: "read"},
{l1: "pròiseil", level: "Hobbies 2", l2: "Proud"},
{l1: "seinnibh", level: "Hobbies 2", l2: "sing (pl, formal)"},
{l1: "sgrìobh", level: "School", l2: "Write"},
{l1: "bi", level: "School", l2: "be"},
{l1: "foghlam", level: "School", l2: "Education"},
{l1: "sgeulachd", level: "School", l2: "Story"},
{l1: "aiste", level: "School", l2: "essay"},
{l1: "faiceallach", level: "School", l2: "careful"},
{l1: "a' cuideachadh", level: "School", l2: "Helping"},
{l1: "matamataig", level: "School", l2: "maths"},
{l1: "leasan", level: "School", l2: "lesson"},
{l1: "sgoilear", level: "School", l2: "pupil"},
{l1: "obair-dachaigh", level: "School", l2: "Homework"},
{l1: "cha do sgrìobh", level: "School", l2: "did not write"},
{l1: "bòrd-geal", level: "School", l2: "whiteboard"},
{l1: "pàipear", level: "School", l2: "Paper"},
{l1: "bun-sgoil", level: "School", l2: "Primary School"},
{l1: "cha do leugh", level: "School", l2: "didn't read"},
{l1: "seòmar-teagaisg", level: "School", l2: "classroom"},
{l1: "cleachd", level: "School", l2: "use"},
{l1: "àrd-sgoil", level: "School", l2: "secondary school"},
{l1: "bòrd-dubh", level: "School", l2: "Blackboard"},
{l1: "glaodh", level: "School", l2: "glue"},
{l1: "a' cleachdadh", level: "School", l2: "Using"},
{l1: "peant", level: "Arts", l2: "Paint"},
{l1: "a' peantadh", level: "Arts", l2: "painting"},
{l1: "dealbhadair", level: "Arts", l2: "photographer"},
{l1: "air leth", level: "Arts", l2: "exceptional"},
{l1: "bruis", level: "Arts", l2: "brush"},
{l1: "dath", level: "Arts", l2: "Color"},
{l1: "dathan", level: "Arts", l2: "Colors"},
{l1: "sgrìobhadair", level: "Arts", l2: "writer"},
{l1: "tìde", level: "Arts", l2: "Time"},
{l1: "fad", level: "Arts", l2: "length, during"},
{l1: "ùghdar", level: "Arts", l2: "Author"},
{l1: "leabhraichean", level: "Arts", l2: "Books"},
{l1: "cleasaiche", level: "Arts", l2: "actor"},
{l1: "rùisgte", level: "Arts", l2: "naked"},
{l1: "àrd-ùrlar", level: "Arts", l2: "stage"},
{l1: "talla-cluiche", level: "Arts", l2: "Theater hall"},
{l1: "pinnt", level: "Arts", l2: "pint"},
{l1: "a' rànaich", level: "Arts", l2: "crying"},
{l1: "dealbh-chluich", level: "Arts", l2: "a play"},
{l1: "tric", level: "Arts", l2: "often"},
{l1: "dràma", level: "Arts", l2: "Drama"},
{l1: "talla", level: "Arts", l2: "Hall"},
{l1: "a' gàireachdainn", level: "Arts", l2: "laughing"},
{l1: "seinneadair", level: "Arts", l2: "Singer"},
{l1: "mòine", level: "Arts", l2: "Peat"},
{l1: "cruthachail", level: "Arts", l2: "creative"},
{l1: "film", level: "Arts", l2: "Film"},
{l1: "dìosal", level: "Arts", l2: "diesel"},
{l1: "dannsair", level: "Arts", l2: "Dancer"},
{l1: "sgrìobhadh", level: "Arts", l2: "Writing"},
{l1: "nas òige", level: "Compare", l2: "younger"},
{l1: "nas sine", level: "Compare", l2: "older"},
{l1: "nas brònaiche", level: "Compare", l2: "sadder"},
{l1: "peadar", level: "Compare", l2: "Peter"},
{l1: "nas luaithe", level: "Compare", l2: "faster"},
{l1: "nas blàithe", level: "Compare", l2: "warmer"},
{l1: "madainn", level: "Compare", l2: "morning"},
{l1: "nas slaodaiche", level: "Compare", l2: "slower"},
{l1: "nas fhuaire", level: "Compare", l2: "colder"},
{l1: "nas aotruime", level: "Compare", l2: "lighter"},
{l1: "nas truime", level: "Compare", l2: "heavier"},
{l1: "riutha", level: "Compare", l2: "with them"},
{l1: "ailbhean", level: "Compare", l2: "an elephant"},
{l1: "draibh", level: "Compare", l2: "drive"},
{l1: "rinn", level: "Compare", l2: "did"},
{l1: "nas glice", level: "Compare", l2: "smarter"},
{l1: "mar-thà", level: "Compare", l2: "already"},
{l1: "nas gòraiche", level: "Compare", l2: "stupider"},
{l1: "coiseachd", level: "Compare", l2: "walk"},
{l1: "fiaclairean", level: "Work 2", l2: "Dentists"},
{l1: "saighdearan", level: "Work 2", l2: "soldiers"},
{l1: "saighdear", level: "Work 2", l2: "Soldier"},
{l1: "fiaclair", level: "Work 2", l2: "dentist"},
{l1: "bheataichean", level: "Work 2", l2: "vets"},
{l1: "oileanach", level: "Work 2", l2: "Student"},
{l1: "bheat", level: "Work 2", l2: "vets"},
{l1: "oileanaich", level: "Work 2", l2: "Students"},
{l1: "gasta", level: "Work 2", l2: "nice, kind"},
{l1: "luchd-smàlaidh", level: "Work 2", l2: "Firefighters"},
{l1: "luchd-lagha", level: "Work 2", l2: "lawyers"},
{l1: "luchd-saidheans", level: "Work 2", l2: "Scientists"},
{l1: "neach-saidheans", level: "Work 2", l2: "scientist"},
{l1: "neach-lagha", level: "Work 2", l2: "lawyers"},
{l1: "amadan", level: "Work 2", l2: "idiot (male)"},
{l1: "òinseach", level: "Work 2", l2: "idiot (female)"},
{l1: "breugach", level: "Work 2", l2: "a liar"},
{l1: "cheannaich", level: "Shop", l2: "bought"},
{l1: "chuir", level: "Shop", l2: "placed"},
{l1: "loidhne", level: "Shop", l2: "line"},
{l1: "notaichean", level: "Shop", l2: "notes"},
{l1: "sgeilp", level: "Shop", l2: "shelf"},
{l1: "giotàr", level: "Shop", l2: "guitar"},
{l1: "reic", level: "Shop", l2: "sold"},
{l1: "a' reic", level: "Shop", l2: "Selling"},
{l1: "sgillinnean", level: "Shop", l2: "pennies"},
{l1: "bàta-luath", level: "Shop", l2: "speed boat"},
{l1: "beartach", level: "Shop", l2: "wealthy"},
{l1: "ghoid", level: "Shop", l2: "stole"},
{l1: "bhruidhinn", level: "Shop", l2: "spoke"},
{l1: "teanta", level: "Shop", l2: "tent"},
{l1: "sporan", level: "Shop", l2: "sporan"},
{l1: "cha do", level: "Shop", l2: "didn't"},
{l1: "lorg", level: "Shop", l2: "found"},
{l1: "bruis-fhiaclan", level: "Shop", l2: "Tooth brush"},
{l1: "fòn", level: "Shop", l2: "phone"},
{l1: "neach-reic", level: "Shop", l2: "seller"},
{l1: "an-asgaidh", level: "Shop", l2: "free"},
{l1: "a' lorg", level: "Shop", l2: "Finding"},
{l1: "sreap", level: "Forest", l2: "climb"},
{l1: "beathach", level: "Forest", l2: "animal"},
{l1: "beathaichean", level: "Forest", l2: "animals"},
{l1: "fiadhaich", level: "Forest", l2: "wild"},
{l1: "damh", level: "Forest", l2: "deer"},
{l1: "madadh-allaidh", level: "Forest", l2: "wolf"},
{l1: "a' tuiteam", level: "Forest", l2: "Falling"},
{l1: "a' sealg", level: "Forest", l2: "hunting"},
{l1: "madaidhean-allaidh", level: "Forest", l2: "wolves"},
{l1: "shreap", level: "Forest", l2: "climbed"},
{l1: "toll", level: "Forest", l2: "a hole"},
{l1: "a' campadh", level: "Forest", l2: "camping"},
{l1: "a' cladhach", level: "Forest", l2: "digging"},
{l1: "thuit", level: "Forest", l2: "fell"},
{l1: "calman", level: "Forest", l2: "pigeon"},
{l1: "nas àirde", level: "Forest", l2: "higher"},
{l1: "nas bòidhche", level: "Forest", l2: "more beautiful"},
{l1: "nas reamhra", level: "Forest", l2: "fatter"},
{l1: "nas caoile", level: "Forest", l2: "thinner"},
{l1: "cumanta", level: "Forest", l2: "common"},
{l1: "bailtean", level: "Forest", l2: "towns"},
{l1: "cailleannach", level: "Forest", l2: "Caledonian"},
{l1: "lus", level: "Forest", l2: "plant"},
{l1: "lusan", level: "Forest", l2: "Plants"},
{l1: "capall-coille", level: "Forest", l2: "capercaillie "},
{l1: "seunta", level: "Forest", l2: "charming"},

]